import React, { useContext, useEffect } from "react";
import { analytics, captureServices } from "../../communication";
import { StepContext } from "../../hooks/StepContext";
import { OrderContext } from "../../hooks/OrderContext";
import Scheduler from '../Scheduler/Scheduler';
import Contact from "../Contact/Contact";
import Review from "../Review/Review";
import PropertyDetails from "../PropertyDetails/PropertyDetails";
import { trackingEvents, TRACKING_NAMESPACE, } from "../../services/schedulerService";
var stepMap = {
    // address: Address,
    // size: Size,
    property_details: PropertyDetails,
    schedule: Scheduler,
    contact: Contact,
    review: Review,
};
export default function StepSwitcher() {
    var _a = useContext(StepContext), step = _a.step, steps = _a.steps;
    var order = useContext(OrderContext).order;
    useEffect(function () {
        var _a, _b;
        analytics.track(TRACKING_NAMESPACE, trackingEvents.CAPTURE_SERVICES_ORDER_PROGRESS, {
            address_latitude: (_a = order === null || order === void 0 ? void 0 : order.address) === null || _a === void 0 ? void 0 : _a.address_latitude,
            address_longitude: (_b = order === null || order === void 0 ? void 0 : order.address) === null || _b === void 0 ? void 0 : _b.address_longitude,
            id: order === null || order === void 0 ? void 0 : order.id,
            step: steps[step].name,
        });
        captureServices.broadcast("stepChange", { step: steps[step].name });
    }, [step]);
    return React.createElement(step ? stepMap[steps[step].name] : stepMap[steps[0].name]);
}
